import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getProjectBridgeOverview = api(async function projectBridgeOverview({ importId } = {}) {
    return query(
        gql`
            query GetProjectBridgeOverview($importId: String) {
                projectBridgeOverview(importId: $importId)
            }
        `,
        { importId },
        { returns: "projectBridgeOverview" }
    )
})
